import { Tooltip } from '@mui/material';
import { useBreakpoint } from 'hooks/useBreakpoint';

/**
 *  This component is used to show a tooltip on Desktop when hovered and on mobile when touched
 **/
export const ResponsiveTooltip = ({ children, title }) => {
  const { isDesktop } = useBreakpoint();
  return (
    <Tooltip
      onClick={(e) => {
        if (!isDesktop) {
          e.preventDefault();
        }
      }}
      enterTouchDelay={0}
      leaveDelay={1000}
      title={title}
    >
      {children}
    </Tooltip>
  );
};
